import { useQuery } from "react-query";
import { useBffAxios } from "@/context/axios/AxiosContext";
import { useAuthUser } from "@/context/auth/AuthContext";
import { cajasDeLaRespuesta } from "@/context/caja/cajasDelNegocio";

export const CAJAS_DEL_NEGOCIO_QUERY_KEY = "caja-cajas-del-negocio";

/**
 * Las cajas de escritorio del negocio, o las de un local, con su presencia y
 * sus pendientes (`GET /pos/terminals`; §2.1 de OFFLINE-POS-RONDA-1.md). Pide
 * «Depósitos» en lectura, que también tienen el cajero y el vendedor.
 */
export function useCajasDelNegocio(
  warehouseId: string | null,
  {
    enabled = true,
    refetchInterval,
  }: { enabled?: boolean; refetchInterval?: number } = {}
) {
  const axios = useBffAxios();
  const businessId = useAuthUser()?.businessId as string | undefined;
  return useQuery(
    [CAJAS_DEL_NEGOCIO_QUERY_KEY, businessId, warehouseId],
    async () =>
      cajasDeLaRespuesta(
        (
          await axios.get("/pos/terminals", {
            params: warehouseId ? { warehouseId } : {},
          })
        ).data
      ),
    {
      enabled: enabled && !!businessId,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 15_000,
      refetchInterval,
    }
  );
}
